import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { VendaAcessorioVeiculoService } from './venda-acessorio/venda-acessorio-veiculo.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { Table } from 'primeng/table';
import { VendaAcessorioVeiculoFiltroService } from './venda-acessorio/venda-acessorio-veiculo-filtro.service';
import { FiltroDealers } from './venda-acessorio/filtro-dealer';

@Component({
  selector: 'app-venda-acessorio-veiculo',
  templateUrl: './venda-acessorio-veiculo.component.html',
  styleUrls: ['./venda-acessorio-veiculo.component.scss']
})
export class VendaAcessorioVeiculoComponent implements OnInit {
  @Input() filtros: any;
  form: FormGroup;
  subscription: any;
  data: Date;
  selecionado: object;
  selecionados = [];
  cols: any[];
  _selectedColumns: any[];
  dados: any[] = [];
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  dataInicial: Date;
  dataFinal: Date;
  chassi: any;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Dealer": "businessIntelligence.acessorioVeiculo.dealer",
    "Chassi": "businessIntelligence.acessorioVeiculo.chassi",
    "Modelo": "businessIntelligence.acessorioVeiculo.modelo",
    "Data de Venda Veículo": "businessIntelligence.acessorioVeiculo.dataVenda",
    "PN Acessórios": "businessIntelligence.acessorioVeiculo.acessorio",
    "Valor de Acessórios": "businessIntelligence.acessorioVeiculo.valorAcessorio",
  }

  constructor(private service: VendaAcessorioVeiculoService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: VendaAcessorioVeiculoFiltroService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder) {

    this.filtros = {};
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      chassi: [''],
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.changeLanguageValue();
    this.loading = true;

    this.cols = [
      { field: 'dealer', header: 'businessIntelligence.acessorioVeiculo.dealer', headerBr: 'Dealer', headerGb: 'Dealer' },
      { field: 'chassi', header: 'businessIntelligence.acessorioVeiculo.chassi', headerBr: 'Chassi', headerGb: 'Chassis' },
      { field: 'modelo', header: 'businessIntelligence.acessorioVeiculo.modelo', headerBr: 'Modelo', headerGb: 'Model' },
      { field: 'dataVenda', header: 'businessIntelligence.acessorioVeiculo.dataVenda', headerBr: 'Data de Venda', headerGb: 'Sale Date' },
      { field: 'codigoAcessorio', header: 'businessIntelligence.acessorioVeiculo.acessorio', headerBr: 'Código do Acessório', headerGb: 'Accessory Code' },
      { field: 'valorTotal', header: 'businessIntelligence.acessorioVeiculo.valorAcessorio', headerBr: 'Valor Total', headerGb: 'Total Value' },
    ];

    this._selectedColumns = this.cols;
    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private getAll() {
    this.loading = true;
    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.chassi.value).subscribe(dados => {
      this.dados = dados.dados;

      this.dados.forEach(element => {
        const atual = this.conversaoLibraConverte.conversaoLibra(element.valorTotal, null, null);
        element.valorTotal = atual;
        element.valorTotalFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
        element.codigoAcessorio = element.codigoAcessorio?.replace(/\n/g, '\n  ');

        if (element.dataVenda != null) {
          element.dataVenda = moment(new Date(element.dataVenda)).format('DD/MM/YYYY');
        }
      });

      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();
    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.loading = true;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();

    this.displayFiltros = false;
  }

  private filtrosSelecionados() {
    const dealers = [];
    this.incluirFiltroDealers(dealers);
    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.chassi.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.chassi.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {

    return this.dadosTranslate[value] || this.translateHeader(value) || value;
  }

  private translateHeader(item) {
    if (item == "businessIntelligence.acessorioVeiculo.dealer") {
      return "Dealer";
    }
    if (item == "businessIntelligence.acessorioVeiculo.chassi") {
      return this.translate.currentLang == "br" ? "Chassi" : "Chassis";
    }
    if (item == "businessIntelligence.acessorioVeiculo.modelo") {
      return this.translate.currentLang == "br" ? "Modelo" : "Model";
    }
    if (item == "businessIntelligence.acessorioVeiculo.dataVenda") {
      return this.translate.currentLang == "br" ? "Data de Venda Veículo" : "Vehicle Sale Date";
    }
    if (item == "businessIntelligence.acessorioVeiculo.acessorio") {
      return this.translate.currentLang == "br" ? "PN Acessório" : "Accessory PN";
    }
    if (item == "businessIntelligence.acessorioVeiculo.valorAcessorio") {
      return this.translate.currentLang == "br" ? "Valor de Acessório" : "Accessory Value";
    }
  }

  public exportExcel() {
    if (this.dados.length > 0) {
      this.exportExcelService.nomeModulo = 'Vendas de Acessórios por Veículos';
      this.exportExcelService.colunasFormatacao = [4];
      this.exportExcelService.formatType = '"R$"#,##0.00';
      this.exportExcelService.ExportTOExcelJSON(this.dados.map(r => {
        let linha = {};

        this._selectedColumns.forEach(c => {
          linha[this.translateHeader(c.header)] = r[c.field];
        });

        return linha;
      }));
    }
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.loading = true;
        this.getAll();
      });
  }

}